module.exports = __webpack_public_path__ + "static/media/menu.3ced01fc.svg";